import { Delete, Post } from '../helpers';

type SecondarySessionVideo = { session: number; static_video_uuid: string; playback_url: string };

export function UpdateSecondarySessionVideo(secondaryVideo: SecondarySessionVideo): Promise<SecondarySessionVideo> {
  return Post({ path: '/v3/admin/events/session/secondaryVideo', body: { secondaryVideo } });
}

export function DeleteSecondarySessionVideo(sessionId: number): Promise<SecondarySessionVideo> {
  return Delete({ path: '/v3/admin/events/session/secondaryVideo', body: { sessionId } });
}
